module.exports = __webpack_public_path__ + "img/newtaiyo3.7cac4c5b.png";